import PropTypes from 'prop-types';

import {
  AddressDefaultProps,
  AddressPropTypes,
} from '@/common/proptypes/Common/Address/Address.proptypes';

export const WarehouseDefaultProps = {
  address: {
    ...AddressDefaultProps,
  },
  code: null,
  name: null,
};

export const WarehousePropTypes = {
  address: PropTypes.shape({
    ...AddressPropTypes,
  }),
  code: PropTypes.string,
  name: PropTypes.string,
};
